<template>
  <div>
      <el-link type="primary" @click="clickModule(value)" style="font-size: 12px;" >{{ value }}</el-link>
  </div>
</template>
<script>
  import { param } from "@/utils";

  export default {
    props: {
      url: {
        default: '',
        type: String
      },
      paramName: {
        default: '',
        type: String
      },
      type:{
        default: '',
        type: String
      }
    },
    data: function () {
      return {
        value: null
      }
    },
    mounted() {

    },
    methods: {
      clickModule(value) {
        let row = this.record;
        const param = {}
        if(this.type.length>0){
          param.type = this.type;
        }
        if(this.paramName.length>0){
          param[this.paramName] = row[this.paramName];
        }
        this.$router.push({
          path: this.url,
          query: param
        })
      }
    }
  }
</script>
<style scoped>
  .stepSuc :hover {
    cursor: pointer;
  }
</style>
